import { render } from "./DaftarProgramBudgeting.vue?vue&type=template&id=2a4c81b0"
import script from "./DaftarProgramBudgeting.vue?vue&type=script&lang=js"
export * from "./DaftarProgramBudgeting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__